<wl-module-events-toolbar *ngIf="_section == 'events'"></wl-module-events-toolbar>
<wl-module-profiles-toolbar *ngIf="_section == 'profiles'"></wl-module-profiles-toolbar>
<wl-module-revenue-toolbar *ngIf="_section === 'revenue'"></wl-module-revenue-toolbar>
<wl-module-events-v4-toolbar *ngIf="_section === 'events-v4'"></wl-module-events-v4-toolbar>
